window.OCR = {
  fileOnChangeHandler: function () {
    if (event.currentTarget.files[0]) {
      $(".ocr-ui").removeClass("hidden");
    } else {
      $(".ocr-ui").addClass("hidden");
    }
  },

  read: function ({ file, textarea, endpoint }) {
    let currentTarget = event.currentTarget;
    if (currentTarget.disabled) return;
    currentTarget.disabled = true;

    let waitingSpinnerEl = $(".ocr-waiting-spinner", $(currentTarget).parent());
    let messageEl = $(".ocr-status-message", $(currentTarget).parent());
    let cancelButton = $(".ocr-cancel", $(currentTarget).parent())[0];

    let textareaEl = $(`[name='${textarea}']`);
    let fileEl = $(`[name='${file}']`);
    let fileData = fileEl.prop("files")[0];

    if (!fileData) {
      messageEl.text("画像が指定されていません");
      messageEl.show();
      setTimeout(() => {
        messageEl.fadeOut();
      }, 3000);
      currentTarget.disabled = false;
    } else {
      let confirmed = window.confirm(
        "画像から文字を読み取ってコメント入力欄に追加します",
      );
      if (!confirmed) {
        currentTarget.disabled = false;
        return;
      }
      let fd = new FormData();
      let csrf_param = $('meta[name="csrf-param"]').attr("content");
      let csrf_token = $('meta[name="csrf-token"]').attr("content");
      fd.append("image", fileData);
      fd.append(csrf_param, csrf_token);
      waitingSpinnerEl.css({ visibility: "visible" });
      $(cancelButton).show();
      cancelButton.canceled = false;
      cancelButton.xhr = $.ajax({
        url: endpoint,
        type: "post",
        data: fd,
        processData: false,
        contentType: false,
        cache: false,
      })
        .done(function (data) {
          if (data.status == "succeeded") {
            let val = textareaEl.val();
            textareaEl.val(
              (val && val.length > 0 ? val + "\n\n" : "") + data.text,
            );
          } else {
            messageEl.text("エラーが発生しました");
            messageEl.show();
            setTimeout(() => {
              messageEl.fadeOut();
            }, 3000);
            window.console.log(data);
          }
        })
        .fail(function (...error) {
          if (cancelButton.canceled) {
            messageEl.text("OCRをキャンセルしました");
          } else {
            messageEl.text("エラーが発生しました");
            window.console.log(error);
          }
          messageEl.show();
          setTimeout(() => {
            messageEl.fadeOut();
          }, 3000);
        })
        .always(function () {
          waitingSpinnerEl.css({ visibility: "hidden" });
          $(cancelButton).hide();
          cancelButton.xhr = null;
          cancelButton.canceled = false;
          currentTarget.disabled = false;
        });
    }
  },

  cancel: function () {
    const cancelButton = event.currentTarget;
    cancelButton.canceled = true;
    if (cancelButton.xhr) cancelButton.xhr.abort();
  },
};
